<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
				<el-form-item>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" size="mini" border>
			<el-table-column prop="id" align="center" label="ID" data-name="id"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题">
				<template slot-scope="scope"><a target="_blank" class="clo3" :href="API_URL+'#/course_activity_info?id='+scope.row.id">{{lang=='cn'?scope.row.theme_cn:scope.row.theme}}</a></template>
			</el-table-column>
			<el-table-column prop="start_date" align="center" :label="$t('course_index.date')" data-name="日期">
				<template slot-scope="scope">{{getTime_us(scope.row.start_date,'mmddyyyy')}} ~ {{getTime_us(scope.row.end_date,'mmddyyyy')}}</template>
			</el-table-column>
			<el-table-column prop="start_time" align="center" :label="$t('course_index.time')" data-name="时间">
				<template slot-scope="scope">{{getTime_us(scope.row.start_time,'hh:ii')}} ~ {{getTime_us(scope.row.end_time,'hh:ii')}}</template>
			</el-table-column>
			<el-table-column prop="surplus" align="center" :label="$t('course_index.max_people')" data-name="班级规模">
				<template slot-scope="scope">{{scope.row.student_num}}/{{scope.row.class_num}}</template>
			</el-table-column>
			<el-table-column prop="age" align="center" :label="$t('course_index.age')" data-name="年龄">
				<template slot-scope="scope">{{scope.row.min_age}}-{{scope.row.max_age}}y</template>
			</el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.price')" data-name="学费"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="340">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)" data-name="编辑">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('copy')" @click.native="copy(scope.row)" data-name="复制">{{$t('index.copy')}}</el-button>
					<el-button size="mini" type="info" v-if="hasBtn('del')" @click="del(scope.row)" data-name="删除">{{$t('index.del')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('Student_list')" @click="router_url('/teacher_activity_list',{id:scope.row.id})" data-name="学生列表">{{$t('course_index.student_list')}}</el-button>
					</el-button>
					<p class="matop">
						<!-- class_starts -->
						<el-button size="mini" type="primary" v-if="hasBtn('status')" data-name="开课" @click="kaike(scope.row)">{{$t('course_index.class_start')}}</el-button>
						<el-button size="mini" type="danger" v-if="hasBtn('status')&&scope.row.is_up==1" data-name="上线" @click="up(scope.row,0)">{{$t('course_index.up_0')}}</el-button>
						<el-button size="mini" type="success" v-if="hasBtn('status')&&scope.row.is_up==0" data-name="下线" @click="up(scope.row,1)">{{$t('course_index.up_1')}}</el-button>
					</p>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" v-if="editFormVisible" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1200px">
			<div class="dialog-header">
				<el-button size="mini" type="primary" class="fint_ma_top" @click.native="field_add">{{$t('course_index.add_field')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
			<el-form label-width="80px" ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="8">
						<el-form-item :label="$t('index.cn')+$t('course_index.theme')" prop="theme_cn" data-name="主题">
							<el-input v-model="editForm.theme_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('index.en')+$t('course_index.theme')" prop="theme" data-name="主题">
							<el-input v-model="editForm.theme" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.price')" prop="price" data-name="价格">
							<el-input v-model="editForm.price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.max_people')" prop="class_num" data-name="班级规模">
							<el-input v-model="editForm.class_num" type="Number" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
							<el-date-picker v-model="editForm.date" class="w100" value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.time')" prop="time" data-name="时间">
							<el-time-picker v-model="editForm.time" class="w100" value-format="timestamp" format="HH:mm" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')" is-range></el-time-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.age')" data-name="年龄">
							<el-row class="tree-content" :gutter="0">
								<el-col :span="11">
									<el-input v-model="editForm.min_age" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-col>
								<el-col class="line" :span="2">-</el-col>
								<el-col :span="11">
									<el-input v-model="editForm.max_age" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('index.cn')+$t('course_index.form_title')" prop="form_title_cn" data-name="">
							<el-input v-model="editForm.form_title_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('index.en')+$t('course_index.form_title')" prop="form_title" data-name="">
							<el-input v-model="editForm.form_title" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				<el-row>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.thumb')" prop="image" data-name="图片">
							
							<upload :value="editForm.image" name="company" @callback="function(res, file){imageSuccess(res, file,'image')}"></upload>
			              <!-- <el-upload class="avatar-uploader" :action="image_up+'uploadImg'" :data="{name:'company'}" :show-file-list="false" :on-success="function(res, file){imageSuccess(res, file,'image')} ">
			                <img v-if="editForm.image" :src="editForm.image" class="avatar">
			                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
			              </el-upload> -->
			            </el-form-item>
					</el-col>
					<el-col :span="18">
						<el-row  :gutter="10" v-for="(item,index) in editForm.field" :key="index">
							<el-col :span="6">
								<el-form-item :label="$t('course_index.field')" :prop="'field.'+index+'.code'" :rules="editFormRules.code" data-name="字段">
									<el-input  v-model="item.code" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item :label="$t('index.cn')+$t('course_index.field_name')" :prop="'field.'+index+'.name_cn'" :rules="editFormRules.name_cn" data-name="字段名">
									<el-input  v-model="item.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item :label="$t('index.en')+$t('course_index.field_name')" :prop="'field.'+index+'.name'" :rules="editFormRules.name" data-name="字段名">
									<el-input  v-model="item.name" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item :label="$t('course_index.is_must')" data-name="是否必填">
									<el-checkbox v-model="item.is_must" :true-label="1" :false-label="0">{{$t('course_index.required')}}</el-checkbox>
								</el-form-item>
							</el-col>
							<el-col :span="2">
								<i class="fint el-icon-remove" @click="field_del(index)"></i>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item :label="$t('course_index.zoom')" prop="zoom" data-name="zoom链接">
							<el-input v-model="editForm.zoom" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 2, maxRows: 2}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.sign_up')" prop="is_show_sign_up" data-name="是否显示报名">
							<el-select v-model="editForm.is_show_sign_up" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?'是':'YES'" :value="1"></el-option>
								<el-option :label="lang=='cn'?'否':'NO'" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('parent_index.seller')" prop="course_seller_id" data-name="销售">
							<el-select v-model="editForm.course_seller_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in courseSellerList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.is_show_front')" prop="is_show_front" data-name="是否显示再首页">
							<el-switch v-model="editForm.is_show_front" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_index.introduce')" prop="content_cn" data-name="说明">
							<editor-bar v-model="editForm.content_cn"></editor-bar>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_index.introduce')" prop="content" data-name="说明">
							<editor-bar v-model="editForm.content"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" class="fint_ma_top" @click.native="field_add">{{$t('course_index.add_field')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="$t('course_index.xuanzyoujian')" :close-on-click-modal="false" :visible.sync="xuanzyoujian_is" width="1200px">
			<el-form label-width="80px" ref="form" size="mini" label-position="top" :rules="editFormRules" :model="form">
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('course_index.youjian_title')" prop="title" data-name="邮件标题">
							<el-input v-model="form.title" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.xuanzyoujian')" prop="tmp_id" data-name="邮件">
							<el-select v-model="form.tmp_id" @change="tmp_id_f" class="w100" :placeholder="$t('index.select')">
								<el-option :label="item.title" :value="item.id" :key="index" v-for="(item,index) in tmplist"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.mail_type')" prop="mail_type" data-name="发送类型">
							<el-select v-model="form.mail_type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.cn:item.en" :value="item.id" :key="index" v-for="(item,index) in mail_type_list"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="form.mail_type==2">
						<el-form-item :label="$t('course_index.student_list')" prop="title" data-name="学生列表">
							<el-checkbox-group v-model="form.child_ids">
								<el-checkbox :label="item.child_id" v-for="(item,index) in student_list" :key="index"><el-badge :is-dot="!item.have_open_mail">{{item.name}}</el-badge></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="tree-content" :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('course_index.xuanzyoujian')" prop="content" data-name="邮件">
				            <editor-bar v-model="form.content" :isClear="false"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="xuanzyoujian_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="xuanzyoujian_f('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import EditorBar from '@/components/wangEnduit.vue'
export default {
	computed: {
		editFormRules(){
			return{
				theme_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('course_index.theme'),
					trigger: 'blur'
				}],
				theme: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('course_index.theme'),
					trigger: 'blur'
				}],
				price: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.price'),
					trigger: 'blur'
				}],
				class_num: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.max_people'),
					trigger: 'blur'
				}],
				date: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.date'),
					trigger: 'change'
				}],
				image: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.thumb'),
					trigger: 'change'
				}],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('course_index.field_name'),
					trigger: 'blur'
				}],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('course_index.field_name'),
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.field'),
					trigger: 'blur'
				},{
					pattern: /^[a-zA-Z_][a-zA-Z0-9_]+$/,
					message: this.$t('course_index.code'),
					trigger: ['blur', 'change']
				}],
				title: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.youjian_title'),
					trigger: 'blur'
				}],
				tmp_id: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.xuanzyoujian'),
					trigger: 'change'
				}],
			}
		},
	},
	components: {
		EditorBar,
	},
	data() {
		return {
			image_up: process.env.API_UP,
			this_:this,
			API_URL:process.env.API_URL,
			filterForm:{},
			list: [],
			editForm: {},
			editFormVisible: false,
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			xuanzyoujian_is:false,
			student_list:[],
			courseSellerList:[],
			form:{
				id:'',
				title:'',
				tmp_id:'',
				mail_type:'',
				child_ids:[],
				content:'',
			},
			tmplist:[],
			mail_type_list:[
				{
					id:1,
					cn:'全部发送',
					en:'Send all',
				},
				{
					id:2,
					cn:'部分发送',
					en:'Send Partial',
				}
			],
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			this.$post('emailTmpList',{type:'class_starts'}).then((res) => {
				this.tmplist=res;
			})
			this.$post('courseScreen', {}).then((res) => {
				this.courseSellerList=res.courseSellerList;
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "activityIndex"
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		add(data,copy) {
			var this_ = this;
			if (data) {
				var url = "activityInfo"
				var datas = {
					id:data.id,
				}
				this_.$post(url, datas).then((res) => {
					var data_data=JSON.parse(JSON.stringify(res));
					this_.editForm = {
						country:'us',
						id: data_data.id,
						theme: data_data.theme,
						theme_cn: data_data.theme_cn,
						content: data_data.content,
						content_cn: data_data.content_cn,
						image: data_data.image,
						description: data_data.description,
						description_cn: data_data.description_cn,
						price: data_data.price,
						teacher_id: data_data.teacher_id,
						start_date: data_data.start_date,
						end_date: data_data.end_date,
						start_time: data_data.start_time,
						end_time: data_data.end_time,
						min_age:data_data.min_age,
						max_age:data_data.max_age,
						class_num: data_data.class_num,
						field:data_data.field,
						form_title_cn:data_data.form_title_cn,
						form_title:data_data.form_title,
						is_show_sign_up:data_data.is_show_sign_up,
						is_show_front:data_data.is_show_front,
						course_seller_id:data_data.course_seller_id,
						zoom:data_data.zoom,
						date:null,
						time:null,
					}
					if (data_data.start_date&&data_data.end_date) {
						var date=[];
						date[0]=data_data.start_date*1000;
						date[1]=data_data.end_date*1000;
						this_.editForm.date=date;
					}
					if (data_data.start_time&&data_data.start_time) {
						var time=[];
						time[0]=data_data.start_time*1000;
						time[1]=data_data.end_time*1000;
						this_.editForm.time=time;
					}
					this_.editFormVisible = true;
				})
			} else {
				this_.editForm = {
					country:'us',
					theme: '',
					theme_cn: '',
					content: '',
					content_cn: '',
					image: '',
					description: '',
					description_cn: '',
					price: '',
					teacher_id: '',
					start_date: '',
					end_date: '',
					start_time: '',
					end_time: '',
					min_age:'',
					max_age:'',
					class_num: '',
					form_title_cn:'',
					is_show_sign_up:1,
					is_show_front:0,
					course_seller_id:'',
					form_title:'',
					zoom:'',
					date:null,
					time:null,
					field:[],
				}
				if (this_.$refs.editForm) {
					this_.$refs.editForm.resetFields();
				}
				this_.editFormVisible = true;
			}
		},
		// 复制
		copy(data){
			var this_ = this;
			var url = "activityInfo"
			var datas = {
				id:data.id,
			}
			this_.$post(url, datas).then((res) => {
				var data_data=JSON.parse(JSON.stringify(res));
				this_.editForm = {
					country:'us',
					id: data_data.id,
					theme: data_data.theme+'-copy',
					theme_cn: data_data.theme_cn+'-复制',
					content: data_data.content,
					content_cn: data_data.content_cn,
					image: data_data.image,
					description: data_data.description,
					description_cn: data_data.description_cn,
					price: data_data.price,
					teacher_id: data_data.teacher_id,
					start_date: data_data.start_date,
					end_date: data_data.end_date,
					start_time: data_data.start_time,
					end_time: data_data.end_time,
					min_age:data_data.min_age,
					max_age:data_data.max_age,
					class_num: data_data.class_num,
					field:data_data.field,
					form_title_cn:data_data.form_title_cn,
					form_title:data_data.form_title,
					zoom:data_data.zoom,
					date:null,
					time:null,
				}
				if (data_data.start_date&&data_data.end_date) {
					var date=[];
					date[0]=data_data.start_date*1000;
					date[1]=data_data.end_date*1000;
					this_.editForm.date=date;
				}
				if (data_data.start_time&&data_data.start_time) {
					var time=[];
					time[0]=data_data.start_time*1000;
					time[1]=data_data.end_time*1000;
					this_.editForm.time=time;
				}
				var url = "activityAction";
				var datas = JSON.parse(JSON.stringify(this_.editForm));
				// 日期
				if (this_.editForm.date&&this_.editForm.date.length) {
					datas['start_date']= this_.shijian(this_.editForm,'start_date');
					datas['end_date']=this_.shijian(this_.editForm,'end_date');
				}
				// 时间
				if (this_.editForm.time&&this_.editForm.time.length) {
					datas['start_time']= this_.shijian(this_.editForm,'start_time');
					datas['end_time']=this_.shijian(this_.editForm,'end_time');
				}
				datas['field']=JSON.stringify(this_.editForm.field);
				delete datas.id;
				var tishi = this_.$t('index.add_success');
				this_.$post(url, datas).then((res) => {
					this_.$message.success(tishi);
					this_.init();
				});
			})
		},
		field_add(){
			var obj={
				code:'',
				name:'',
				name_cn:'',
				is_must:0,
			}
			this.editForm.field.push(obj);
		},
		field_del(index){
			this.removeByIndex(this.editForm.field,index);
		},
		// 点击保存按键
		editSubmit() {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var url = "activityAction";
					var datas = JSON.parse(JSON.stringify(this_.editForm));
					// 日期
					if (this_.editForm.date&&this_.editForm.date.length) {
						datas['start_date']= this_.shijian(this_.editForm,'start_date');
						datas['end_date']=this_.shijian(this_.editForm,'end_date');
					}
					// 时间
					if (this_.editForm.time&&this_.editForm.time.length) {
						datas['start_time']= this_.shijian(this_.editForm,'start_time');
						datas['end_time']=this_.shijian(this_.editForm,'end_time');
					}
					datas['field']=JSON.stringify(this_.editForm.field);
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "activityDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 上下线
		up(data,value){
			var this_ = this;
			var url = "changeField";
			var datas = {
				pk_id: data.id,
				table:'activity',
				field:'is_up',
				value:value,
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.init();
			})
		},
		// 设置开始结束时间
		shijian(data,quj){
			if(data.date){
			    var start_date=data.date[0];
			    var end_date=data.date[1];
			}else{
			    var start_date=data.start_date*1000;
			    var end_date=data.end_date*1000;
			}
			if (data.time) {
			    var start_time=data.time[0];
			    var end_time=data.time[1];
			}else{
			    var start_time=data.start_time*1000;
			    var end_time=data.end_time*1000;
			}
			if (quj=='start_date') {
			    var y=this.getti(start_date,'y');
			    var m=this.getti(start_date,'m');
			    var d=this.getti(start_date,'d');
			    var h=this.getti(start_time,'h');
			    var i=this.getti(start_time,'i');
			    var s=this.getti(start_time,'s');
			}else if(quj=='end_date'){
			    var y=this.getti(end_date,'y');
			    var m=this.getti(end_date,'m');
			    var d=this.getti(end_date,'d');
			    var h=this.getti(end_time,'h');
			    var i=this.getti(end_time,'i');
			    var s=this.getti(end_time,'s');
			} else if (quj=='start_time'){
			    var y=this.getti(start_date,'y');
			    var m=this.getti(start_date,'m');
			    var d=this.getti(start_date,'d');
			    var h=this.getti(start_time,'h');
			    var i=this.getti(start_time,'i');
			    var s=this.getti(start_time,'s');
			} else if (quj=='end_time'){
			    var y=this.getti(end_date,'y');
			    var m=this.getti(end_date,'m');
			    var d=this.getti(end_date,'d');
			    var h=this.getti(end_time,'h');
			    var i=this.getti(end_time,'i');
			    var s=this.getti(end_time,'s');
			}
			let datetime = Math.round(new Date(y,m,d,h,i,s).getTime()/1000);
			return datetime
		},
		getti(data,ss){
			let datetime = new Date(data);
		    let year = datetime.getFullYear();
		    let month = datetime.getMonth();
		    let date = datetime.getDate();
		    let hour = datetime.getHours();
		    let minute = datetime.getMinutes();
		    let second = datetime.getSeconds();
		    if (ss=='y') {
		    	return year
		    }else if(ss=='m'){
		    	return month
		    }else if(ss=='d'){
		    	return date
		    }else if(ss=='h'){
		    	return hour
		    }else if(ss=='i'){
		    	return minute
		    }else if(ss=='s'){
		    	return second
		    }
		},
		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm[name] = res.data.showname;
				this.image = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
		kaike(data){
			// 获取学生列表
			var this_ = this;
			var url = "courseClasses"
			var datas = {
				course_id: data.id,
				type:'activity',
			}
			this_.$post(url, datas).then((res) => {
				this_.student_list=res.student;
				this_.form={
					id:data.id,
					title:'',
					tmp_id:'',
					mail_type:'',
					child_ids:[],
					content:'',
				}
				this_.xuanzyoujian_is=true;
			})
		},
		// 选择邮件模板后显示邮件内容
		tmp_id_f(){
			var this_ = this;
			var tmplist=this_.tmplist;
			var tmp_id=this_.form.tmp_id;
			tmplist.forEach(function(e,i) {
				if (e.id==tmp_id) {
					this_.form.content=JSON.parse(JSON.stringify(e.content));
				}
			});
		},
		// 发送邮件
		xuanzyoujian_f(){
			var this_ = this;
			this_.$refs.form.validate((valid) => {
				if (valid) {
					var url="openCourseSendEmail";
					var datas={
						course_id:this_.form.id,
						course_type:'activity',
						title:this_.form.title,
						content:this_.form.content,
						child_ids:'',
					}
					if (this_.form.mail_type==2) {
						datas.child_ids=this_.form.child_ids.join(',');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.xuanzyoujian_is=false;
						this_.init();
					})
				}
			})
		},
	},
	// 过滤器
	filters: {
	}
}
</script>
<style scoped>
.matop{
	margin-top: 10px;
}
.clo3{
	color: #ff0000;
}
.filter-inline-panel {
	margin-bottom: 18px;
}
.filter-panel {
	display: inline-block;
	width:calc( 100% - 215px );
	vertical-align: top;
}
.dialog-header{
	text-align: right;
	padding-bottom: 20px;
}
.line{
	text-align: center;
}
.el-date-editor.w100{
	width: 100%;
}
.fint {
	font-size: 28px;
	margin-top: 30px;
	cursor: pointer;
}
.fint_ma_top{
	margin-top: 30px;
}
</style>
<style type="text/css">
textarea{
	font-family: inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/activity.vue